import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import { handleSaveCredentials } from 'utils/LoginUtils/smartLoginHelper';
export var login;
(function (login) {
    login["USER_LOGIN_REQUEST"] = "USER_LOGIN_REQUEST";
    login["USER_LOGIN_SUCCESS"] = "USER_LOGIN_SUCCESS";
    login["USER_LOGIN_ERROR"] = "USER_LOGIN_ERROR";
})(login || (login = {}));
export function loginRequestSuccess(data, userData) {
    if (userData) {
        handleSaveCredentials(userData);
    }
    return { type: login.USER_LOGIN_SUCCESS, data };
}
export function makeLoginRequest(_body, isSmartLock = false) {
    return (dispatch) => {
        dispatch({
            type: login.USER_LOGIN_REQUEST
        });
        let userData = null;
        let loginConfig = {
            pathname: '/api/4/user/authenticate',
            acceptErrors: true,
            sendToSentry: false,
            action: login.USER_LOGIN_REQUEST
        };
        if (isSmartLock) {
            loginConfig.credentials = 'include';
            userData = {
                id: _body.loginId,
                password: _body.password,
                name: _body.name || '',
                iconURL: ''
            };
        }
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, loginConfig), _body).then(json => dispatch(loginRequestSuccess(json['RESPONSE'], userData)), err => Promise.reject(dispatch({
            type: login.USER_LOGIN_ERROR,
            error: err
        })));
    };
}
